import {
  ObservableState,
  reducedStream,
  toPersistentStream,
} from '@ardoq/rxbeach';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { reducers } from './reducers';
import { getDefaultState } from './utils';
import { AdvancedSearchConditionStreamShape } from './types';
import { fields$ } from 'streams/fields/fields$';
import { locale$ } from 'streams/locale$';

const advancedSearchConditionBase$ = reducedStream(
  'advancedSearchConditionBase$',
  getDefaultState(),
  reducers
);

const advancedSearchCondition$: ObservableState<AdvancedSearchConditionStreamShape> =
  toPersistentStream(
    'advancedSearchCondition$',
    combineLatest([advancedSearchConditionBase$, fields$, locale$]).pipe(
      map(([state, fields, locale]) => ({
        ...state,
        fields: fields.models,
        locale,
      }))
    ),
    getDefaultState()
  );

export { advancedSearchCondition$ };
